import React, { useRef, useEffect } from "react";

type DoughnutChartProps = {
  data: number[];
  colors: string[];
  size?: number;
  text?: string;
  title: string;
};

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  data,
  colors,
  size = 32,
  text,
  title,
}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, size, size);

    const total = data.reduce((sum, val) => sum + val, 0);
    let startAngle = -0.5 * Math.PI;

    data.forEach((value, i) => {
      const sliceAngle = (value / total) * Math.PI * 2;

      ctx.beginPath();
      ctx.moveTo(size / 2, size / 2);
      ctx.arc(
        size / 2,
        size / 2,
        size / 2,
        startAngle,
        startAngle + sliceAngle
      );
      ctx.closePath();
      ctx.fillStyle = colors[i % colors.length];
      ctx.fill();

      startAngle += sliceAngle;
    });

    ctx.globalCompositeOperation = "destination-out";
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, size / 3, 0, Math.PI * 2);
    ctx.fill();
    ctx.globalCompositeOperation = "source-over";

    if (text) {
      ctx.fillStyle = "#000";
      ctx.font = `${size / 3}px ABBvoice`;
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(text, size / 2, size / 2 + 1);
    }
  }, [data, colors, size, text]);

  return (
    <canvas
      ref={canvasRef}
      width={size}
      height={size}
      title={title}
      aria-label={title}
    />
  );
};

export default DoughnutChart;
